/**
 * Description:
 * 1. Mục đích: Quản lý kết nối socket, sub và unsub room
 */

import { closeSocketAction, connectSocketAction, subSocketMarketAction, unSubSocketMarketAction } from '@/stores/dataManager/Actions/socketAction';

export const connectSocketMarket = () => {
    connectSocketAction()
    window.addEventListener('beforeunload', () => {
        // Khắc phục cảnh báo Back/Forward Cache (bfcache)
        // Đóng kết nối WebSocket khi rời khỏi trang
        closeSocketAction();
    });
}

export const subSocketMarketManager = (params: { callerId: string, idPbTab: string, symbols: string[] }) => {
    // connectSocket()
    // console.log("subSocketMarket.:", params)
    unSubSocketMarketAction(params)
    subSocketMarketAction(params)
}

export const connectSocketUser = () => {
    connectSocketAction()
    // window.addEventListener('beforeunload', () => {
    //     // Khắc phục cảnh báo Back/Forward Cache (bfcache)
    //     // Đóng kết nối WebSocket khi rời khỏi trang
    //     closeSocketAction();
    // });
}

export const subSocketUserManager = (params: { callerId: string, }) => {

}